import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useBeneficiaryTenderOfferSelectorModal } from '../context/BeneficiaryTenderOfferSelectorModalContext';

const BeneficiaryTenderOfferSelectorModalFooter: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useBeneficiaryTenderOfferSelectorModal();

  return (
    <Modal.Footer>
      <button
        type="button"
        className="btn btn-lg btn-primary"
        onClick={actions.handleSeeTenderOffer}
        disabled={!data.selectedTenderOfferOption}
      >
        {t('SeeOffer')}
      </button>
    </Modal.Footer>
  );
};

export default BeneficiaryTenderOfferSelectorModalFooter;
